module.exports = __webpack_public_path__ + "static/media/utilsPhoneFormats.e1abede2.data";